import {zim } from '../../zegoConfig';
import { generateZegoToken } from '../utils/generateToken'; // Pastikan path ini sesuai dengan struktur project kamu

export const loginToZego = async (userId: string, username: string): Promise<boolean> => {
  try {
    // Generate token lokal
    console.log('🔑 Meminta token untuk userId:', userId);

    const zegoToken = generateZegoToken(userId, 3600); // Token berlaku 1 jam

    console.log('Token Zego (local):', zegoToken);

    if (!zegoToken) throw new Error('Token Zego kosong');

    await zim.login(
      { userID: userId, userName: username },
      zegoToken
    );

    console.log('✅ Login ZIM berhasil');
    return true;
  } catch (err) {
    console.error('❌ Gagal login ke ZIM:', err);
    return false;
  }
};
